import uniqueId from "lodash/uniqueId";

export const generateAppId = (appInstanceIndex: number) => uniqueId(`${appInstanceIndex}-`);
